import styled from 'styled-components';
import Card from '@material-ui/core/Card';
export const StyledCard = styled(Card)`
  && {
    width: auto;
    margin: 0px;
    margin-top: -24px;
    overflow: auto;
    box-shadow: none;
  }
`;